export default __webpack_public_path__ + "static/media/photo.ccab6a7b.svg";